// Generated by scripts/write-fish-shop-replay-fixtures.ts.
// Do not edit manually.

import type { FishShopReplayEventType } from "./event-adapter";

export interface FishShopReplayFixturePlayer {
  readonly id: string;
  readonly name: string;
  readonly role: "host" | "player";
}

export interface FishShopReplayFixtureEvent {
  readonly sequenceNumber: number;
  readonly eventType: FishShopReplayEventType;
  readonly userId: string;
  readonly payload: Record<string, unknown>;
}

export interface FishShopReplayFixture {
  readonly schemaVersion: 1;
  readonly gameType: "fish-shop";
  readonly scenario: string;
  readonly source: "generated";
  readonly capturedAt: string;
  readonly seed: number;
  readonly observerUserId: string;
  readonly players: readonly FishShopReplayFixturePlayer[];
  readonly events: readonly FishShopReplayFixtureEvent[];
  readonly notes: readonly string[];
}

export const FISH_SHOP_REPLAY_FIXTURES: Record<string, FishShopReplayFixture> =
  {
    "simple-3p-live": {
      schemaVersion: 1,
      gameType: "fish-shop",
      scenario: "simple-3p-live",
      source: "generated",
      capturedAt: "2026-06-09T00:00:00.000Z",
      seed: 2026060903,
      observerUserId: "observer",
      players: [
        {
          id: "p1",
          name: "Fish 01",
          role: "host",
        },
        {
          id: "p2",
          name: "Fish 02",
          role: "player",
        },
        {
          id: "p3",
          name: "Fish 03",
          role: "player",
        },
      ],
      events: [
        {
          sequenceNumber: 1,
          eventType: "init",
          userId: "p1",
          payload: {
            state: {
              gameId: "fish-shop-replay-simple-3p-live",
              status: "IN_PROGRESS",
              roundCount: 1,
              currentRound: {
                roundNumber: 1,
                phase: "TICKET_ALLOCATION",
                allocations: {},
                market: {
                  HAIRTAIL: {
                    productId: "HAIRTAIL",
                    sellers: [],
                    soldTicketCount: 0,
                  },
                  MACKEREL: {
                    productId: "MACKEREL",
                    sellers: [],
                    soldTicketCount: 0,
                  },
                  SQUID: {
                    productId: "SQUID",
                    sellers: [],
                    soldTicketCount: 0,
                  },
                },
                priceSubmissions: {},
                secretSelections: {},
                productResults: [],
                incomeByPlayerId: {},
                confirmedPlayerIds: [],
              },
              completedRounds: [],
              players: [
                {
                  playerId: "p1",
                  remainingTickets: 6,
                  totalIncomeWon: 0,
                  itemStatus: "AVAILABLE",
                  checkSnapshotWon: null,
                },
                {
                  playerId: "p2",
                  remainingTickets: 6,
                  totalIncomeWon: 0,
                  itemStatus: "AVAILABLE",
                  checkSnapshotWon: null,
                },
                {
                  playerId: "p3",
                  remainingTickets: 6,
                  totalIncomeWon: 0,
                  itemStatus: "AVAILABLE",
                  checkSnapshotWon: null,
                },
              ],
              winnerIds: [],
              lowestPlayerIds: [],
              garnetAwardsByPlayerId: {},
              restartNumber: 0,
              hostPlayerId: "p1",
              seed: 2026060903,
            },
          },
        },
        {
          sequenceNumber: 2,
          eventType: "SyncViewerState",
          userId: "p1",
          payload: {
            actionId: "simple-3p-live:sync-initial-view",
          },
        },
        {
          sequenceNumber: 3,
          eventType: "AllocateTickets",
          userId: "p1",
          payload: {
            ticketsByProduct: {
              HAIRTAIL: 2,
              MACKEREL: 0,
              SQUID: 0,
            },
          },
        },
        {
          sequenceNumber: 4,
          eventType: "AllocateTickets",
          userId: "p2",
          payload: {
            ticketsByProduct: {
              HAIRTAIL: 1,
              MACKEREL: 0,
              SQUID: 0,
            },
          },
        },
        {
          sequenceNumber: 5,
          eventType: "AllocateTickets",
          userId: "p3",
          payload: {
            ticketsByProduct: {
              HAIRTAIL: 0,
              MACKEREL: 1,
              SQUID: 0,
            },
          },
        },
        {
          sequenceNumber: 6,
          eventType: "UseCheck",
          userId: "p1",
          payload: {},
        },
        {
          sequenceNumber: 7,
          eventType: "UseSecret",
          userId: "p3",
          payload: {
            productId: "HAIRTAIL",
          },
        },
        {
          sequenceNumber: 8,
          eventType: "SubmitPrices",
          userId: "p1",
          payload: {
            prices: {
              HAIRTAIL: 1000,
            },
          },
        },
        {
          sequenceNumber: 9,
          eventType: "SubmitPrices",
          userId: "p2",
          payload: {
            prices: {
              HAIRTAIL: 2000,
            },
          },
        },
        {
          sequenceNumber: 10,
          eventType: "SubmitPrices",
          userId: "p3",
          payload: {
            prices: {
              MACKEREL: 5000,
            },
          },
        },
        {
          sequenceNumber: 11,
          eventType: "ConfirmRoundResult",
          userId: "p1",
          payload: {},
        },
        {
          sequenceNumber: 12,
          eventType: "ConfirmRoundResult",
          userId: "p2",
          payload: {},
        },
        {
          sequenceNumber: 13,
          eventType: "ConfirmRoundResult",
          userId: "p3",
          payload: {},
        },
      ],
      notes: [
        "Fish Shop replay fixtures model game-platform viewer-state snapshots, not raw private state rendering.",
        "The observer sees allocation readiness before market lock, but never pre-reveal ticket quantities or price submissions.",
        "UseSecret hides HAIRTAIL result values, and UseCheck remains visible only through the checking player's private viewer state.",
      ],
    },
  };
